"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.f116 = void 0;
exports.f116 = {
    "ta": [
        "Taml",
        "Brai"
    ],
    "taa": [
        "Latn"
    ],
    "tab": [
        "Cyrl"
    ],
    "tac": [
        "Latn"
    ],
    "tad": [
        "Latn"
    ],
    "tae": [
        "Latn"
    ],
    "taf": [
        "Latn"
    ],
    "tag": [
        "Zyyy"
    ],
    "taj": [
        "Deva",
        "Tibt"
    ],
    "tak": [
        "Latn"
    ],
    "tal": [
        "Latn"
    ],
    "tan": [
        "Latn"
    ],
    "tao": [
        "Latn"
    ],
    "tap": [
        "Latn"
    ],
    "taq": [
        "Latn",
        "Tfng"
    ],
    "tar": [
        "Latn"
    ],
    "tas": [
        "Latn"
    ],
    "tau": [
        "Latn"
    ],
    "tav": [
        "Latn"
    ],
    "taw": [
        "Latn"
    ],
    "tax": [
        "Latn"
    ],
    "tay": [
        "Latn",
        "Hans",
        "Hant"
    ],
    "taz": [
        "Latn"
    ],
    "tba": [
        "Latn"
    ],
    "tbb": [
        "Latn"
    ],
    "tbc": [
        "Latn"
    ],
    "tbd": [
        "Latn"
    ],
    "tbe": [
        "Latn"
    ],
    "tbf": [
        "Latn"
    ],
    "tbg": [
        "Latn"
    ],
    "tbh": [
        "Latn"
    ],
    "tbi": [
        "Latn"
    ],
    "tbj": [
        "Latn"
    ],
    "tbk": [
        "Tagb",
        "Latn"
    ],
    "tbl": [
        "Latn"
    ],
    "tbm": [
        "Latn"
    ],
    "tbn": [
        "Latn"
    ],
    "tbo": [
        "Latn"
    ],
    "tbp": [
        "Latn"
    ],
    "tbr": [
        "Zyyy"
    ],
    "tbs": [
        "Latn"
    ],
    "tbt": [
        "Latn"
    ],
    "tbu": [
        "Latn"
    ],
    "tbv": [
        "Latn"
    ],
    "tbw": [
        "Latn",
        "Tagb"
    ],
    "tbx": [
        "Latn"
    ],
    "tby": [
        "Latn"
    ],
    "tbz": [
        "Latn"
    ],
    "tca": [
        "Latn"
    ],
    "tcb": [
        "Latn"
    ],
    "tcc": [
        "Latn"
    ],
    "tcd": [
        "Latn"
    ],
    "tce": [
        "Latn"
    ],
    "tcf": [
        "Latn"
    ],
    "tcg": [
        "Latn"
    ],
    "tch": [
        "Latn"
    ],
    "tci": [
        "Latn"
    ],
    "tck": [
        "Latn"
    ],
    "tcl": [
        "Zyyy"
    ],
    "tcm": [
        "Latn"
    ],
    "tcn": [
        "Zyyy"
    ],
    "tco": [
        "Zyyy"
    ],
    "tcp": [
        "Latn"
    ],
    "tcq": [
        "Latn"
    ],
    "tcs": [
        "Latn"
    ],
    "tct": [
        "Zyyy"
    ],
    "tcu": [
        "Latn"
    ],
    "tcw": [
        "Latn"
    ],
    "tcx": [
        "Taml"
    ],
    "tcy": [
        "Knda",
        "Zzzz"
    ],
    "tcz": [
        "Latn"
    ],
    "tda": [
        "Arab",
        "Latn",
        "Tfng"
    ],
    "tdb": [
        "Deva",
        "Beng",
        "Kthi"
    ],
    "tdc": [
        "Latn"
    ],
    "tdd": [
        "Tale"
    ],
    "tde": [
        "Latn"
    ],
    "tdf": [
        "Zyyy"
    ],
    "tdg": [
        "Deva",
        "Tibt"
    ],
    "tdh": [
        "Deva"
    ],
    "tdi": [
        "Latn"
    ],
    "tdj": [
        "Latn"
    ],
    "tdk": [
        "Latn"
    ],
    "tdl": [
        "Latn"
    ],
    "tdm": [
        "Latn"
    ],
    "tdn": [
        "Latn"
    ],
    "tdo": [
        "Latn"
    ],
    "tdq": [
        "Latn"
    ],
    "tdr": [
        "Latn"
    ],
    "tds": [
        "Latn"
    ],
    "tdt": [
        "Latn"
    ],
    "tdv": [
        "Latn"
    ],
    "tdx": [
        "Latn"
    ],
    "tdy": [
        "Latn"
    ],
    "te": [
        "Telu",
        "Brai"
    ],
    "tea": [
        "Latn"
    ],
    "teb": [
        "Latn"
    ],
    "tec": [
        "Latn"
    ],
    "ted": [
        "Latn"
    ],
    "tee": [
        "Latn"
    ],
    "tef": [
        "Zyyy"
    ],
    "teg": [
        "Latn"
    ],
    "teh": [
        "Latn"
    ],
    "tei": [
        "Latn"
    ],
    "tek": [
        "Latn"
    ],
    "tem": [
        "Latn"
    ],
    "ten": [
        "Latn"
    ],
    "teo": [
        "Latn"
    ],
    "tep": [
        "Latn"
    ],
    "teq": [
        "Latn"
    ],
    "ter": [
        "Latn"
    ],
    "tes": [
        "Java"
    ],
    "tet": [
        "Latn"
    ],
    "teu": [
        "Latn"
    ],
    "tev": [
        "Latn"
    ],
    "tew": [
        "Latn"
    ],
    "tex": [
        "Latn"
    ],
    "tey": [
        "Latn"
    ],
    "tez": [
        "Latn",
        "Tfng"
    ],
    "tfi": [
        "Latn"
    ],
    "tfn": [
        "Latn"
    ],
    "tfo": [
        "Latn"
    ],
    "tfr": [
        "Latn"
    ],
    "tft": [
        "Latn"
    ],
    "tg": [
        "Cyrl",
        "Arab",
        "Hebr",
        "Latn"
    ],
    "tga": [
        "Latn"
    ],
    "tgb": [
        "Latn"
    ],
    "tgc": [
        "Latn"
    ],
    "tgd": [
        "Latn"
    ],
    "tge": [
        "Deva"
    ],
    "tgf": [
        "Tibt"
    ],
    "tgh": [
        "Latn"
    ],
    "tgi": [
        "Latn"
    ],
    "tgj": [
        "Latn"
    ],
    "tgn": [
        "Latn"
    ],
    "tgo": [
        "Latn"
    ],
    "tgp": [
        "Latn"
    ],
    "tgq": [
        "Latn"
    ],
    "tgr": [
        "Zyyy"
    ],
    "tgs": [
        "Latn"
    ],
    "tgt": [
        "Latn"
    ],
    "tgu": [
        "Latn"
    ],
    "tgv": [
        "Latn"
    ],
    "tgw": [
        "Latn"
    ],
    "tgx": [
        "Latn"
    ],
    "tgy": [
        "Latn"
    ],
    "tgz": [
        "Latn"
    ],
    "th": [
        "Thai",
        "Brai"
    ],
    "thd": [
        "Latn"
    ],
    "the": [
        "Deva"
    ],
    "thf": [
        "Deva"
    ],
    "thh": [
        "Latn"
    ],
    "thi": [
        "Tale"
    ],
    "thk": [
        "Latn"
    ],
    "thl": [
        "Deva"
    ],
    "thm": [
        "Zyyy"
    ],
    "thn": [
        "Zyyy"
    ],
    "thp": [
        "Latn",
        "Dupl"
    ],
    "thq": [
        "Deva"
    ],
    "thr": [
        "Deva"
    ],
    "ths": [
        "Deva"
    ],
    "tht": [
        "Latn"
    ],
    "thu": [
        "Latn"
    ],
    "thv": [
        "Arab",
        "Latn",
        "Tfng"
    ],
    "thy": [
        "Latn"
    ],
    "thz": [
        "Latn",
        "Tfng"
    ],
    "ti": [
        "Ethi",
        "Arab"
    ],
    "tia": [
        "Zyyy"
    ],
    "tic": [
        "Latn"
    ],
    "tif": [
        "Latn"
    ],
    "tig": [
        "Ethi",
        "Arab",
        "Latn"
    ],
    "tih": [
        "Latn"
    ],
    "tii": [
        "Latn"
    ],
    "tij": [
        "Deva"
    ],
    "tik": [
        "Latn"
    ],
    "til": [
        "Zyyy"
    ],
    "tim": [
        "Latn"
    ],
    "tin": [
        "Cyrl"
    ],
    "tio": [
        "Latn"
    ],
    "tip": [
        "Latn"
    ],
    "tiq": [
        "Latn"
    ],
    "tis": [
        "Latn"
    ],
    "tit": [
        "Latn"
    ],
    "tiu": [
        "Latn"
    ],
    "tiv": [
        "Latn"
    ],
    "tiw": [
        "Latn"
    ],
    "tix": [
        "Latn"
    ],
    "tiy": [
        "Latn"
    ],
    "tiz": [
        "Zyyy"
    ],
    "tja": [
        "Latn"
    ],
    "tjg": [
        "Latn"
    ],
    "tji": [
        "Latn"
    ],
    "tjj": [
        "Latn"
    ],
    "tjl": [
        "Mymr"
    ],
    "tjm": [
        "Latn"
    ],
    "tjn": [
        "Latn"
    ],
    "tjo": [
        "Zyyy"
    ],
    "tjp": [
        "Latn"
    ],
    "tjs": [
        "Latn"
    ],
    "tju": [
        "Latn"
    ],
    "tjw": [
        "Latn"
    ],
    "tk": [
        "Latn",
        "Arab",
        "Cyrl"
    ],
    "tka": [
        "Latn"
    ],
    "tkb": [
        "Deva"
    ],
    "tkd": [
        "Latn"
    ],
    "tke": [
        "Latn"
    ],
    "tkf": [
        "Latn"
    ],
    "tkg": [
        "Latn"
    ],
    "tkl": [
        "Latn"
    ],
    "tkm": [
        "Zyyy"
    ],
    "tkn": [
        "Zyyy"
    ],
    "tkp": [
        "Latn"
    ],
    "tkq": [
        "Latn"
    ],
    "tkr": [
        "Latn",
        "Cyrl"
    ],
    "tks": [
        "Arab"
    ],
    "tkt": [
        "Deva"
    ],
    "tku": [
        "Latn"
    ],
    "tkv": [
        "Latn"
    ],
    "tkw": [
        "Latn"
    ],
    "tkx": [
        "Latn"
    ],
    "tkz": [
        "Latn"
    ],
    "tl": [
        "Latn",
        "Brai",
        "Buhd",
        "Tglg"
    ],
    "tla": [
        "Latn"
    ],
    "tlb": [
        "Latn"
    ],
    "tlc": [
        "Latn"
    ],
    "tld": [
        "Latn"
    ],
    "tlf": [
        "Latn"
    ],
    "tlg": [
        "Latn"
    ],
    "tlh": [
        "Piqd",
        "Latn"
    ],
    "tli": [
        "Latn",
        "Cyrl"
    ],
    "tlj": [
        "Latn"
    ],
    "tlk": [
        "Latn"
    ],
    "tll": [
        "Latn"
    ],
    "tlm": [
        "Latn"
    ],
    "tln": [
        "Latn"
    ],
    "tlo": [
        "Zyyy"
    ],
    "tlp": [
        "Latn"
    ],
    "tlq": [
        "Latn"
    ],
    "tlr": [
        "Latn"
    ],
    "tls": [
        "Latn"
    ],
    "tlt": [
        "Latn"
    ],
    "tlu": [
        "Latn"
    ],
    "tlv": [
        "Latn"
    ],
    "tlx": [
        "Latn"
    ],
    "tly": [
        "Latn",
        "Arab",
        "Cyrl"
    ],
    "tma": [
        "Latn"
    ],
    "tmb": [
        "Latn"
    ],
    "tmc": [
        "Latn"
    ],
    "tmd": [
        "Latn"
    ],
    "tme": [
        "Latn"
    ],
    "tmf": [
        "Latn"
    ],
    "tmg": [
        "Latn"
    ],
    "tmh": [
        "Latn",
        "Arab",
        "Tfng"
    ],
    "tmi": [
        "Latn"
    ],
    "tmj": [
        "Latn"
    ],
    "tmk": [
        "Deva"
    ],
    "tml": [
        "Latn"
    ],
    "tmm": [
        "Latn"
    ],
    "tmn": [
        "Latn"
    ],
    "tmo": [
        "Latn"
    ],
    "tmq": [
        "Latn"
    ],
    "tmr": [
        "Syrc"
    ],
    "tms": [
        "Zyyy"
    ],
    "tmt": [
        "Latn"
    ],
    "tmu": [
        "Latn"
    ],
    "tmv": [
        "Latn"
    ],
    "tmw": [
        "Latn"
    ],
    "tmy": [
        "Latn"
    ],
    "tmz": [
        "Latn"
    ],
    "tn": [
        "Latn"
    ],
    "tna": [
        "Latn"
    ],
    "tnb": [
        "Latn"
    ],
    "tnc": [
        "Latn"
    ],
    "tnd": [
        "Latn"
    ],
    "tng": [
        "Latn"
    ],
    "tnh": [
        "Latn"
    ],
    "tni": [
        "Latn"
    ],
    "tnk": [
        "Latn"
    ],
    "tnl": [
        "Latn"
    ],
    "tnm": [
        "Latn"
    ],
    "tnn": [
        "Latn"
    ],
    "tno": [
        "Latn"
    ],
    "tnp": [
        "Latn"
    ],
    "tnq": [
        "Latn"
    ],
    "tnr": [
        "Latn"
    ],
    "tns": [
        "Latn"
    ],
    "tnt": [
        "Latn"
    ],
    "tnu": [
        "Zyyy"
    ],
    "tnv": [
        "Cakm"
    ],
    "tnw": [
        "Latn"
    ],
    "tnx": [
        "Latn"
    ],
    "tny": [
        "Latn"
    ],
    "tnz": [
        "Zyyy"
    ],
    "to": [
        "Latn"
    ],
    "tob": [
        "Latn"
    ],
    "toc": [
        "Latn"
    ],
    "tod": [
        "Latn"
    ],
    "tof": [
        "Latn"
    ],
    "tog": [
        "Latn"
    ],
    "toh": [
        "Latn"
    ],
    "toi": [
        "Latn"
    ],
    "toj": [
        "Latn"
    ],
    "tol": [
        "Latn"
    ],
    "tom": [
        "Latn"
    ],
    "too": [
        "Latn"
    ],
    "top": [
        "Latn"
    ],
    "toq": [
        "Latn"
    ],
    "tor": [
        "Latn"
    ],
    "tos": [
        "Latn"
    ],
    "tou": [
        "Latn"
    ],
    "tov": [
        "Arab"
    ],
    "tow": [
        "Latn"
    ],
    "tox": [
        "Latn"
    ],
    "toy": [
        "Latn"
    ],
    "toz": [
        "Latn"
    ],
    "tpa": [
        "Latn"
    ],
    "tpc": [
        "Latn"
    ],
    "tpe": [
        "Beng",
        "Latn"
    ],
    "tpf": [
        "Latn"
    ],
    "tpg": [
        "Latn"
    ],
    "tpi": [
        "Latn"
    ],
    "tpj": [
        "Latn"
    ],
    "tpk": [
        "Latn"
    ],
    "tpl": [
        "Latn"
    ],
    "tpm": [
        "Latn"
    ],
    "tpn": [
        "Latn"
    ],
    "tpo": [
        "Zyyy"
    ],
    "tpp": [
        "Latn"
    ],
    "tpq": [
        "Zyyy"
    ],
    "tpr": [
        "Latn"
    ],
    "tpt": [
        "Latn"
    ],
    "tpu": [
        "Khmr"
    ],
    "tpv": [
        "Latn"
    ],
    "tpw": [
        "Latn"
    ],
    "tpx": [
        "Latn"
    ],
    "tpy": [
        "Latn"
    ],
    "tpz": [
        "Latn"
    ],
    "tqb": [
        "Latn"
    ],
    "tql": [
        "Latn"
    ],
    "tqm": [
        "Latn"
    ],
    "tqn": [
        "Latn"
    ],
    "tqo": [
        "Latn"
    ],
    "tqp": [
        "Latn"
    ],
    "tqq": [
        "Zyyy"
    ],
    "tqr": [
        "Zyyy"
    ],
    "tqt": [
        "Latn"
    ],
    "tqu": [
        "Latn"
    ],
    "tqw": [
        "Latn"
    ],
    "tr": [
        "Latn",
        "Arab",
        "Brai",
        "Cyrl",
        "Grek"
    ],
    "tra": [
        "Arab"
    ],
    "trb": [
        "Latn"
    ],
    "trc": [
        "Latn"
    ],
    "trd": [
        "Zyyy"
    ],
    "tre": [
        "Latn"
    ],
    "trf": [
        "Latn"
    ],
    "trg": [
        "Hebr"
    ],
    "trh": [
        "Latn"
    ],
    "tri": [
        "Latn"
    ],
    "trj": [
        "Latn"
    ],
    "trl": [
        "Zyyy"
    ],
    "trm": [
        "Arab"
    ],
    "trn": [
        "Latn"
    ],
    "tro": [
        "Latn"
    ],
    "trp": [
        "Beng",
        "Latn"
    ],
    "trq": [
        "Latn"
    ],
    "trr": [
        "Latn"
    ],
    "trs": [
        "Latn"
    ],
    "trt": [
        "Latn"
    ],
    "tru": [
        "Latn",
        "Syrc"
    ],
    "trv": [
        "Latn"
    ],
    "trw": [
        "Arab"
    ],
    "trx": [
        "Latn"
    ],
    "try": [
        "Latn"
    ],
    "trz": [
        "Latn"
    ],
    "ts": [
        "Latn",
        "Brai"
    ],
    "tsa": [
        "Latn"
    ],
    "tsb": [
        "Latn"
    ],
    "tsc": [
        "Latn"
    ],
    "tsd": [
        "Grek"
    ],
    "tse": [
        "Zxxx"
    ],
    "tsg": [
        "Latn",
        "Arab"
    ],
    "tsh": [
        "Latn"
    ],
    "tsi": [
        "Latn"
    ],
    "tsj": [
        "Tibt"
    ],
    "tsk": [
        "Zyyy"
    ],
    "tsl": [
        "Latn"
    ],
    "tsm": [
        "Zxxx"
    ],
    "tsp": [
        "Latn"
    ],
    "tsq": [
        "Zxxx"
    ],
    "tsr": [
        "Latn"
    ],
    "tss": [
        "Zxxx"
    ],
    "tst": [
        "Latn"
    ],
    "tsu": [
        "Latn"
    ],
    "tsv": [
        "Latn"
    ],
    "tsw": [
        "Latn"
    ],
    "tsx": [
        "Latn"
    ],
    "tsy": [
        "Zxxx"
    ],
    "tsz": [
        "Latn"
    ],
    "tt": [
        "Cyrl",
        "Latn"
    ],
    "tta": [
        "Zyyy"
    ],
    "ttb": [
        "Latn"
    ],
    "ttc": [
        "Latn"
    ],
    "ttd": [
        "Latn"
    ],
    "tte": [
        "Latn"
    ],
    "ttf": [
        "Latn"
    ],
    "ttg": [
        "Zyyy"
    ],
    "tth": [
        "Laoo"
    ],
    "tti": [
        "Latn"
    ],
    "ttj": [
        "Latn"
    ],
    "ttk": [
        "Latn"
    ],
    "ttl": [
        "Latn"
    ],
    "ttm": [
        "Latn"
    ],
    "ttn": [
        "Latn"
    ],
    "tto": [
        "Laoo"
    ],
    "ttp": [
        "Latn"
    ],
    "ttr": [
        "Latn"
    ],
    "tts": [
        "Thai"
    ],
    "ttt": [
        "Latn",
        "Arab",
        "Cyrl"
    ],
    "ttu": [
        "Latn"
    ],
    "ttv": [
        "Latn"
    ],
    "ttw": [
        "Latn"
    ],
    "tty": [
        "Latn"
    ],
    "ttz": [
        "Zyyy"
    ],
    "tua": [
        "Latn"
    ],
    "tub": [
        "Latn"
    ],
    "tuc": [
        "Latn"
    ],
    "tud": [
        "Latn"
    ],
    "tue": [
        "Latn"
    ],
    "tuf": [
        "Latn"
    ],
    "tug": [
        "Latn"
    ],
    "tuh": [
        "Latn"
    ],
    "tui": [
        "Latn"
    ],
    "tuj": [
        "Latn"
    ],
    "tul": [
        "Latn"
    ],
    "tum": [
        "Latn"
    ],
    "tun": [
        "Zyyy"
    ],
    "tuo": [
        "Latn"
    ],
    "tuq": [
        "Latn"
    ],
    "tus": [
        "Latn"
    ],
    "tuu": [
        "Latn"
    ],
    "tuv": [
        "Latn"
    ],
    "tux": [
        "Latn"
    ],
    "tuy": [
        "Latn"
    ],
    "tuz": [
        "Latn"
    ],
    "tva": [
        "Latn"
    ],
    "tvd": [
        "Latn"
    ],
    "tve": [
        "Latn"
    ],
    "tvk": [
        "Latn"
    ],
    "tvl": [
        "Latn"
    ],
    "tvm": [
        "Latn"
    ],
    "tvn": [
        "Zyyy"
    ],
    "tvo": [
        "Latn"
    ],
    "tvs": [
        "Latn"
    ],
    "tvt": [
        "Latn"
    ],
    "tvu": [
        "Latn"
    ],
    "tvw": [
        "Latn"
    ],
    "tvx": [
        "Latn"
    ],
    "tvy": [
        "Zyyy"
    ],
    "twa": [
        "Zyyy"
    ],
    "twb": [
        "Latn"
    ],
    "twc": [
        "Zyyy"
    ],
    "twd": [
        "Latn"
    ],
    "twe": [
        "Latn"
    ],
    "twf": [
        "Latn"
    ],
    "twg": [
        "Latn"
    ],
    "twh": [
        "Latn",
        "Tavt"
    ],
    "twl": [
        "Latn"
    ],
    "twm": [
        "Deva"
    ],
    "twn": [
        "Latn"
    ],
    "two": [
        "Latn"
    ],
    "twp": [
        "Latn"
    ],
    "twq": [
        "Latn"
    ],
    "twr": [
        "Latn"
    ],
    "twt": [
        "Latn"
    ],
    "twu": [
        "Latn"
    ],
    "tww": [
        "Latn"
    ],
    "twx": [
        "Latn"
    ],
    "twy": [
        "Latn"
    ],
    "txa": [
        "Latn"
    ],
    "txb": [
        "Zyyy",
        "Mani"
    ],
    "txc": [
        "Zyyy"
    ],
    "txe": [
        "Latn"
    ],
    "txg": [
        "Tang"
    ],
    "txh": [
        "Zyyy"
    ],
    "txi": [
        "Latn"
    ],
    "txj": [
        "Latn"
    ],
    "txm": [
        "Latn"
    ],
    "txn": [
        "Latn"
    ],
    "txo": [
        "Beng",
        "Deva",
        "Toto"
    ],
    "txq": [
        "Latn"
    ],
    "txr": [
        "Zyyy"
    ],
    "txs": [
        "Latn"
    ],
    "txt": [
        "Latn"
    ],
    "txu": [
        "Latn"
    ],
    "txx": [
        "Latn"
    ],
    "txy": [
        "Latn"
    ],
    "ty": [
        "Latn"
    ],
    "tya": [
        "Latn"
    ],
    "tye": [
        "Latn"
    ],
    "tyh": [
        "Latn"
    ],
    "tyi": [
        "Latn"
    ],
    "tyj": [
        "Latn",
        "Zzzz"
    ],
    "tyl": [
        "Latn"
    ],
    "tyn": [
        "Latn"
    ],
    "typ": [
        "Latn"
    ],
    "tyr": [
        "Tavt"
    ],
    "tys": [
        "Latn"
    ],
    "tyt": [
        "Latn",
        "Tavt"
    ],
    "tyu": [
        "Latn"
    ],
    "tyv": [
        "Cyrl"
    ],
    "tyx": [
        "Latn"
    ],
    "tyy": [
        "Latn"
    ],
    "tyz": [
        "Latn"
    ],
    "tza": [
        "Zxxx"
    ],
    "tzh": [
        "Latn"
    ],
    "tzj": [
        "Latn"
    ],
    "tzl": [
        "Latn"
    ],
    "tzm": [
        "Latn",
        "Arab",
        "Tfng"
    ],
    "tzn": [
        "Latn"
    ],
    "tzo": [
        "Latn"
    ],
    "tzx": [
        "Latn"
    ]
};
